import React from 'react'
import Navbar from '../components/Sidebar'
import Header from '../components/HeaderCar'
const CardImg = 'https://fnicdn.blob.core.windows.net/regionh/maps/thumb/Regional_Planning_Groups%20-%20Copy.jpg'
const RegionPlanGrpjpg = 'https://fnicdn.blob.core.windows.net/regionh/maps/Regional_Planning_Groups.jpg';

export default function AboutRegioPlan() {
    return (
        <div>
            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container'>
                    <div className='row ps-lg-4'>
                        <h3>About Regional Planning</h3>
                        <div className='col-lg-8'>
                            <p>
                                In 1997 the State Legislature, through Senate Bill 1, determined that the Texas State Water Plan for the 2000-2050 time frame, would be developed through a regional water planning approach.
                                To accomplish this task, the Texas Water Development Board (TWDB) divided the state into 16 regional water planning areas and appointed representational Regional Water Planning Groups (RWPG) that have guided the development of each region’s plan.
                                The planning effort is part of a consensus-based planning effort to include local concerns in the statewide planning effort and continues to be the model which guides the development of the State Water Plan.
                            </p>
                            <p>
                                Water resource planning and management in Texas is a shared responsibility of local utilities, regional special purpose districts, and state agencies.
                                Local and regional water development authorities and municipalities have had primary responsibility for financing and constructing new water resource projects.
                            </p>
                            <p>
                                More information is available on the Texas Water Development Board's <a href="http://www.twdb.texas.gov/waterplanning/rwp/index.asp" target="_blank">Regional Water Planning webpage.</a>
                            </p>
                        </div>
                        <div className='col-lg-4 mb-3'>
                            <div className="card" style={{ backgroundColor: "#f2f2f2" }} >
                                <img src={CardImg} className="card-img-top pt-2 px-2" />
                                <div className="card-body">
                                    <a href={RegionPlanGrpjpg} target="_blank" className=' text-decoration-none'><h6 className="card-subtitle">Click here for a higher-resolution image of the Regional Water Planning Areas</h6></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div >
    )
}
